import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-flex-auto tw-flex tw-items-center tw-text-center"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-md tw-ml-auto",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m16.312 9.76-1.008.992 3.072 3.36H9.24v1.44h9.136l-3.072 3.36 1.008.992 4.592-5.072-4.592-5.072Z",
    fill: "inherit"
  })
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.block)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createCommentVNode(" Featured Block "),
        _createElementVNode("div", {
          class: _normalizeClass(["tw-p-xl xl:tw-px-30 tw-rounded-20 tw-flex tw-flex-col tw-w-full single-product-card tw-bg-center tw-bg-no-repeat tw-bg-cover tw-flex-grow tw-min-h-420", 'tw-bg-' + _ctx.block.background_colour]),
          style: _normalizeStyle({
        background: `background: linear-gradient(180deg, rgba(0, 0, 0, 0.258) 56.66%, rgba(0, 0, 0, 0.6) 100%), url(${_ctx.block.background_image}) center center / cover no-repeat`,
      })
        }, [
          (_ctx.block.overlay_text != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h3", {
                  class: _normalizeClass(["tw-w-full h3-extra-large tw-uppercase tw-text-center", {
            'tw-text_white':
              _ctx.block.background_image && _ctx.block.background_image.length > 0,
          }])
                }, _toDisplayString(_ctx.block.overlay_text), 3 /* TEXT, CLASS */)
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.block.link_url)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "btn btn-secondary xs:tw-bg-white tw-no-underline tw-w-full",
                href: _ctx.block.link_url
              }, [
                _createTextVNode(_toDisplayString(_ctx.block.link_text) + " ", 1 /* TEXT */),
                _hoisted_3
              ], 8 /* PROPS */, _hoisted_2))
            : _createCommentVNode("v-if", true)
        ], 6 /* CLASS, STYLE */),
        _createCommentVNode(" / Featured Block ")
      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    : _createCommentVNode("v-if", true)
}